import { combineReducers } from 'redux';
import toast from './toast';
import auth from './auth';
import user from './user';
import farm from './farm';
import crew from './crew';
import crewKanban from './crew-kanban';
import equipmentGroup from './equipment-group';
import egKanban from './eg-kanban';
import hardware from './hardware';
import equipment from './equipment';
import person from './person';
import analyze from './analyze';
import reports from './reports';
import map from './map';
import socket from './socket';
import chat from './chat';
import geo from './geo';
import load from './load';
import dashboard from './dashboard';
import farmMonitor from './farm-monitor';
import users from './users';
import organization from './organization';
import notification from './notification';
import messagePolicy from './message-policy';
import plan from './plan';
import logistics from './logistics';
import oem from './oem';
import customer from './customer';
import network from './networkType';
import scoutObservation from './scout-observation';
import scoutKanban from './scout-kanban';
import remoteScale from './remote-scale';
import scaleSocket from './scale-socket';
import distance from './distance';
import rateSchedule from './rate-schedule';
import scaleDevice from './scale-device';

export default combineReducers({
    toast, auth, user, users, farm, crew, crewKanban, equipmentGroup, egKanban,
    equipment, person, analyze, reports, map, socket, chat, hardware, geo, load,
    dashboard, farmMonitor, organization, notification, messagePolicy, plan, oem,
    customer, network, logistics, scoutObservation, scoutKanban, remoteScale, scaleSocket, distance, rateSchedule, scaleDevice
});
